import { styled, Theme } from '@mui/material';

export const sxStyles = {
  commonAppTitle: {
    fontSize: '36px',
    marginBottom: '0.5rem',
  },
  commonAppSubtitle: (theme: Theme) => ({
    color: theme.palette.grey['700'],
  }),
  manageRolesBtn: {
    marginTop: '1.5rem',
    maxWidth: '224px',
  },
};

export const StyledHeadSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '0 2.5rem 2rem 2.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.down('sm')]: {
    padding: '0 1.25rem 1.25rem 1.25rem',
  },
}));

export const StyledCommonAppWrap = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  maxWidth: '700px',
  width: '100%',
  marginTop: '1.5rem',
}));
